import React from 'react';
import {ComputedPageItem} from '@taopix/taopix-core/dist/types/types';
import {AssistantType, ViewMode} from '@taopix/taopix-core';
import {useUiState} from '../../../Context/UserInterface/UserInterfaceContext';
import {ThreeDPreviewStatus} from '../../../../Enums';
import ThreeDPreview from '../../../ThreeDPreview/ThreeDPreview';
import Sidebar from './Sidebar';
import {useExperience} from '../../../Experience/ExperienceProvider';
import useViewMode from '../../../../Hooks/useViewMode';
import {useTranslation} from 'react-i18next';

export type SidebarContainerProps = {
  selectedItem: ComputedPageItem;
};

const SidebarContainer = ({selectedItem}: SidebarContainerProps) => {
  const {experience} = useExperience();
  const [viewMode] = useViewMode();
  const ui = useUiState();
  const {t} = useTranslation(['toolpalette']);

  if (ViewMode.Preview === viewMode) {
    return <></>;
  }

  return (
    <aside
      aria-label={t('toolpalette:str_LabelToolPalettes', {defaultValue: 'Tool Palettes'})}
      id={'toolpalette'}
      className="flex flex-col sm:order-1 sm:z-[1000] relative"
    >
      <Sidebar selectedItem={selectedItem} viewMode={viewMode} />

      {ThreeDPreviewStatus.None !== ui.state.threeDPreviewStatus &&
        experience.EDITOR.workArea.previewMode.use3dPreview && (
          <ThreeDPreview
            isSmallScreen={ui.state.isSmallScreen}
            fullScreen={
              ui.state.fromAssistant.fromAssistant &&
              ui.state.fromAssistant.assistantRan &&
              AssistantType.PictureSelectionOnly ===
                experience.WIZARD.designAssistantType.designAssistantType
            }
            status={ui.state.threeDPreviewStatus}
          />
        )}
    </aside>
  );
};

export default SidebarContainer;
